export default {
    menus() {
        return [
            {
                cn: '首页',
                pages: [
                    { cn: '统计', path: 'home' },
                ]
            }, {
                cn: '信息管理',
                pages: [
                    { cn: '通知公告', path: 'notices' },
                    { hidden: true, cn: '通知公告详情', path: 'notice' },
                    { cn: '用户协议/隐私政策', path: 'agreements' },
                    { hidden: true, cn: '用户协议/隐私政策详情', path: 'agreement' },
                    { cn: '导览图标库', path: 'scenicIcons' },
                    { cn: '景区导览', path: 'scenic' },
                ]
            }, {
                cn: '停车场信息',
                pages: [
                    { cn: '入场记录', path: 'parkEnters' },
                    { cn: '出场记录', path: 'parkOuts' },
                ]
            }, {
                cn: '共享单车',
                pages: [
                    { cn: '停车区设置', path: 'bikePark' },
                    { cn: '车辆类型', path: 'bikeTypes' },
                    { hidden: true, cn: '车辆类型详情', path: 'bikeType' },
                    { cn: '车辆管理', path: 'bikes' },
                    { hidden: true, cn: '车辆新增', path: 'bike' },
                    { cn: '骑行订单', path: 'bikeOrders' },
                    { cn: '故障上报处理', path: 'bikeBrokens' },
                    { cn: '车锁日志', path: 'bikeLockLogs' },
                ]
            }, {
                cn: '客户信息',
                pages: [
                    { cn: '客户列表', path: 'accounts' },
                ]
            }, {
                cn: '后台设置',
                pages: [
                    { cn: '个人中心', path: 'my' },
                    { cn: '权限管理', path: 'roleList' },
                    { hidden: true, cn: '权限详情', path: 'roleDetail' },
                    { cn: '后台用户', path: 'userList' },
                    { hidden: true, cn: '后台用户详情', path: 'userDetail' },
                ]
            }
        ]
    },
    filter(hidden, paths) {
        const menus = this.menus()
        for (let menuIndex = menus.length - 1; menuIndex >= 0; menuIndex--) {
            const menu = menus[menuIndex]
            if (menu != null && menu.pages != null) {
                for (let pageIndex = menu.pages.length - 1; pageIndex >= 0; pageIndex--) {
                    let splice = false
                    const page = menu.pages[pageIndex]
                    if (hidden === true && !page.hidden) {
                        splice = true
                    }
                    if (hidden === false && page.hidden) {
                        splice = true
                    }
                    if (paths != null && paths.length > 0 && !paths.includes(page.path)) {
                        splice = true
                    }
                    if (splice) {
                        menu.pages.splice(pageIndex, 1)
                    }
                }
            }
            if (menu == null || menu.pages == null || menu.pages.length == 0) {
                menus.splice(menuIndex, 1)
            }
        }
        return menus
    }
}